import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-sb-text',
  templateUrl: './sb-text.component.html',
  styleUrls: ['./sb-text.component.scss'],
  standalone: false,
})
export class SBTextComponent implements OnInit {
  @Input() caption;
  @Input() title;

  constructor() {}

  ngOnInit() {}
}
